export const ORGANIZATIONS_TABLE_KEYS = {
	DISCONNECT: 'disconnect',
	IS_SANDBOX: 'isSandbox',
	LAST_SYNC: 'lastSync',
	ORGANIZATION_NAME: 'organizationName',
	PACKAGE_TAGGING: 'packageTagging',
	REAUTHORIZE: 'reauthorize',
	SYNC_STATUS: 'syncStatus'
};
